import Link from 'next/link';

type ExternalLinkProps = {
  href: string;
  linkText?: string;
  className?: string;
  external?: boolean;
  externalIconName?: string;
};

export const ExternalLink = (props: ExternalLinkProps) => {
  const {
    href,
    linkText,
    className,
    external = true,
    externalIconName = 'fa-external-link',
  } = props;

  return (
    <Link
      href={href}
      passHref={true}
      target="_blank"
      rel={external ? 'noopener noreferrer' : undefined}
      className={className}
    >
      {linkText || href}
      <i className={`fa ${externalIconName} mg-l-5`}></i>
    </Link>
  );
};

ExternalLink.displayName = '@signate-cloud/ExternalLink';
